// export const BASE_URL = "http://localhost:5500";
// export const BASE_URL = "https://saryuparivar-back-end.onrender.com";
// export const BASE_URL = "http://13.203.154.185:443";
export const BASE_URL = "https://api.saryuparinbrahman.com";
